import {actionNameGenerator} from "../../../../utils/commonUtil"

const domainPrefix = "sac";
const sacActionNameGenerator = actionNameGenerator(domainPrefix);
export const receiveDropDownValuesType = sacActionNameGenerator("receiveDropDownValues");
export const validateFieldsType = sacActionNameGenerator("validateFields");
export const clearValidationType = sacActionNameGenerator("clearValidation");
export const suggestCharityType = sacActionNameGenerator("suggestCharity");
export const changePopUpStatusType = sacActionNameGenerator("changePopUpStatus");
export const addToSavedCharityType = sacActionNameGenerator("addToSavedCharity");
export const clearCharityListType = sacActionNameGenerator("clearCharityList");
export const suggestCharitySuccessType = sacActionNameGenerator("suggestCharitySuccess");
export const addtoSavedCharitySuccessType = sacActionNameGenerator("addtoSavedCharitySuccessType");
export const  dropDownMappingSuccessType = sacActionNameGenerator("dropDownMappingSuccess");
export const  dropdDownMappingFailType  = sacActionNameGenerator("dropdDownMappingFail");
export const suggestCharityFailType = sacActionNameGenerator("suggestCharityFail");
export const addToSavedCharityFailType = sacActionNameGenerator("addToSavedCharityFail");
